import { render, staticRenderFns } from "./book-demo.vue?vue&type=template&id=49e7d4eb"
import script from "./book-demo.vue?vue&type=script&lang=js"
export * from "./book-demo.vue?vue&type=script&lang=js"
import style0 from "./book-demo.vue?vue&type=style&index=0&id=49e7d4eb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports